import React, { useEffect, useState } from 'react';
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import ServiceData from "../../components/Service/ServiceData/ServiceData";
import { ServiceDataProps } from "../../components/Service/ServiceData/ServiceDataTypes";

const CrearServicio = (): React.ReactElement => {
  const [menuProps] = useState<MenuProps>(defaultMenuProps);
  const [serviceData] = useState<ServiceDataProps>({ service: { _id: '' } });
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <React.Fragment>
      <div id="menu">
        <Menu items={menuProps.items} />
      </div>
      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Crear servicio</h1>
          <span></span>
        </header>
        {loaded && <ServiceData service={serviceData.service} />}
      </div>
    </React.Fragment>
  );
};

export default CrearServicio;
